<template>
  <div>
    <scroller :on-refresh="refresh">
      <div class="container">
        <div class="row">
          <div class="col-md-8" style="margin: 0 auto">
            <div class="header">
              <!-- 顶部搜索框 -->
              <div class="header_img">
                <img src="../../assets/img/lumi.png" />
              </div>
              <label @click="search" class="searchLabel">
                <mt-search
                  cancel-text="取消"
                  placeholder="请输入直播名称"
                ></mt-search>
              </label>
            </div>
            <div class="indexView">
              <!-- 轮播图组件 -->
              <mt-swipe class="swipe">
                <mt-swipe-item v-for="(item, index) in bannerList" :key="index">
                  <a
                    :href="
                      item.liStatus === 2
                        ? `${baseUrl}catDetail?catId=${item.catId}`
                        : item.liStatus === 1
                        ? `${baseUrl}details?liveId=${item.liveId}`
                        : item.liBannerClickToUrl
                    "
                  >
                    <img :src="item.liBannerImg" />
                  </a>
                </mt-swipe-item>
              </mt-swipe>
              <div class="list">
                <div>
                  <router-link to="/live">
                    <img src="../../assets/img/new.png" alt />
                    <p>直播预告</p>
                  </router-link>
                </div>
                <div @click="goStatus">
                  <img src="../../assets/img/playback.png" alt />
                  <p>精彩回放</p>
                </div>
                <div>
                  <router-link to="/hotTopics">
                    <img src="../../assets/img/hot.png" alt />
                    <p>热门关注</p>
                  </router-link>
                </div>

                <div>
                  <router-link to="/superiorProduct">
                    <img src="../../assets/img/superior.png" alt />
                    <p>智播优品</p>
                  </router-link>
                </div>
              </div>
              <!-- 主题 -->
              <div class="column columns">
                <img src="../../assets/img/list1.png" />
                <span class="column_p">专题版块</span>
              </div>
              <div class="specialList">
                <div
                  class="theme_sm"
                  v-for="item in columnList"
                  :key="item.liveId"
                  @click="getColTabbar(item.catId)"
                >
                  <div class="theme-img">
                    <img :src="item.catCoverImg" />
                  </div>
                  <div class="theme-text">
                    <van-notice-bar
                      :text="item.catName"
                      background="none"
                      style="
                        padding: 0;
                        color: #333;
                        font-size: 16px;
                        line-height: 30px;
                      "
                    />
                  </div>
                </div>
                <div
                  class="theme"
                  v-for="item in columnList_odd"
                  :key="item.liveId"
                  @click="getColTabbar(item.catId)"
                >
                  <div class="theme-img">
                    <img :src="item.catCoverImg" />
                  </div>
                  <div class="theme-text">
                    <van-notice-bar
                      :text="item.catName"
                      background="none"
                      style="
                        padding: 0;
                        color: #333;
                        font-size: 16px;
                        line-height: 30px;
                      "
                    />
                  </div>
                </div>
              </div>
              <!-- 主体 -->
              <main>
                <!-- 推荐列表 -->
                <div>
                  <div class="columns">
                    <img src="../../assets/img/recommend.png" />
                    <span class="column_p">热播推荐</span>
                  </div>
                  <div class="infoItem">
                    <!-- 图文项目内容 -->
                    <div
                      class="infoItemContent"
                      v-for="(item, index) in dataForm.liveList"
                      :key="index"
                      @click="getDetail(item.liveId)"
                    >
                      <!-- 图片 -->
                      <div class="liveImg">
                        <img
                          class="infoItemImg"
                          :src="item.liveCoverImg"
                          alt="暂无图片"
                        />
                        <div class="liveStatus">
                          {{
                            item.liveStatus === 0
                              ? '即将直播'
                              : item.liveStatus === 1
                              ? '直播中'
                              : '历史直播'
                          }}
                        </div>
                      </div>
                      <!-- 图文项目文本 -->
                      <div class="inforItemText">
                        <!-- 图文项目标题 -->
                        <div class="infoItemTitle">
                          <p>{{ item.liveName }}</p>
                        </div>
                        <!-- 图文项目讲师 -->
                        <div class="infoItemDes">
                          <p>{{ item.liveLecturers }}</p>
                        </div>
                        <div class="infoItemPrice">
                          <span class="price" v-if="item.livePay === 0"
                            >¥&nbsp;{{ item.liveAmt.toFixed(2) }}</span
                          >
                          <span class="free" v-if="item.livePay === 1"
                            >免费</span
                          >
                          <span
                            v-if="
                              item.liveStatus === 2 &&
                                !item.total &&
                                item.liveAttr
                            "
                            class="count"
                          >
                            <span>
                              <img src="../../assets/img/yanjing.png" alt />
                              {{ JSON.parse(item.liveAttr).lookNum }}
                            </span>
                          </span>
                        </div>
                        <div class="infoItemDes2" v-if="item.liveStatus === 0">
                          <span
                            >开始时间：{{
                              item.liveStartTime.substring(0, 19)
                            }}</span
                          >
                        </div>
                        <div class="infoItemDes2" v-if="item.liveStatus === 1">
                          <span
                            >结束时间：{{
                              item.liveEndTime.substring(0, 19)
                            }}</span
                          >
                        </div>
                      </div>
                    </div>
                    <div
                      class="noCourse"
                      v-show="dataForm.liveList.length <= 0"
                    >
                      暂无相关直播，敬请期待！
                    </div>
                    <div
                      v-if="pageIndex < dataForm.totalPage"
                      style="
                        text-align: center;
                        font-size: 12px;
                        color: #666;
                        margin-top: 10px;
                      "
                      @click="loadMore"
                    >
                      点击加载更多...
                    </div>
                    <div
                      v-else
                      style="
                        text-align: center;
                        font-size: 12px;
                        color: #666;
                        margin-top: 10px;
                      "
                    >
                      暂无更多直播...
                    </div>
                  </div>
                </div>
              </main>
            </div>
          </div>
        </div>
      </div>
    </scroller>
    <!-- 底部选项卡 -->
    <div class="container">
      <div class="row">
        <mt-tabbar
          :selected="selected"
          class="col-md-8"
          style="margin: 0 auto; max-width: 760px"
        ></mt-tabbar>
      </div>
    </div>
  </div>
</template>

<script>
import MtTabbar from '../../components/Tabbar'
import Header from '../../components/index/Header'
import InfoItem from '../../components/InfoItem'
// import { refreshToken } from '../../common/refreshToken'
import {
  shareIndex,
  shareTitle,
  shareUrl,
  shareImg,
  shareDesc
} from '@/common/wxshare'
export default {
  data() {
    return {
      allLoaded: false,
      selected: 'home',
      columnList: [],
      columnList_odd: [],
      bannerList: [],
      baseUrl: process.env.VUE_APP_PAGEURL,
      user: {},
      dataForm: {
        currPage: 0,
        liveList: [],
        pageSize: 0,
        totalCount: 0,
        totalPage: 0
      },
      pageIndex: 1,
      busy: false
    }
  },
  components: {
    MtTabbar,
    Header,
    InfoItem
  },
  mounted() {
    const _this = this
    _this.getColumnList()
    _this.getBannerList()
    _this.getLiveList()
    _this.wxShare()
    // let userInfo = sessionStorage.getItem('userInfo')
    // if (!userInfo) {
    //   refreshToken(this)
    // }
  },
  methods: {
    goStatus() {
      this.$store.commit('changeSelectedValue', '2')
      // this.$router.push('/live')
      const routeData = this.$router.resolve({
        path: '/live'
      })
      window.open(routeData.href, '_blank')
    },
    search() {
      // this.$router.push('/search')
      const routeData = this.$router.resolve({
        path: '/search'
      })
      window.open(routeData.href, '_blank')
    },
    refresh() {
      location.reload()
    },
    onBridgeReady: function() {
      WeixinJSBridge.call('hideOptionMenu')
    },

    // 加载更多
    loadMore() {
      this.pageIndex++
      if (this.pageIndex <= this.dataForm.totalPage) {
        this.getLiveList()
      }
    },
    getDetail(liveId) {
      // this.$router.push({
      //   path: '/details',
      //   query: {
      //     liveId: liveId
      //   }
      // })
      const routeData = this.$router.resolve({
        path: '/details',
        query: {
          liveId: liveId
        }
      })
      window.open(routeData.href, '_blank')
    },
    // 获取指定分类直播列表
    getLiveList() {
      this.$http({
        url: '/live/live/queryList/',
        method: 'get',
        params: {
          liveIsTop: 0,
          page: this.pageIndex,
          limit: 10
        }
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.dataForm.liveList = this.dataForm.liveList.concat(data.data.list)
          this.dataForm.pageSize = data.data.pageSize
          this.dataForm.totalCount = data.data.totalCount
          this.dataForm.totalPage = data.data.totalPage
          this.dataForm.currPage = data.data.currPage
        } else {
          this.dataForm.liveList = []
          this.pageIndex = 1
        }
      })
    },
    // 跳转到主题tabbar页
    getColTabbar(catId) {
      // this.$router.push({
      //   path: '/catDetail',
      //   query: {
      //     catId: catId
      //   }
      // })
      const routeData = this.$router.resolve({
        path: '/catDetail',
        query: {
          catId: catId
        }
      })
      window.open(routeData.href, '_blank')
    },
    // 获取轮播图
    getBannerList() {
      this.$http({
        url: '/live/liBanner/list',
        method: 'post',
        params: { liBannerIsEnable: 0 }
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.bannerList = data.data.list
        } else {
          this.bannerList = []
        }
      })
    },
    // 获取主题列表
    getColumnList() {
      this.$http({
        url: 'live/liveCategory/list/tree',
        method: 'get'
      }).then(({ data }) => {
        if (data && data.code === 0) {
          if (data.data.length > 0 && data.data.length % 2 === 0) {
            this.columnList = data.data
          } else {
            this.columnList = data.data.slice(0, data.data.length - 1)
            this.columnList_odd = data.data.slice(
              data.data.length - 1,
              data.data.length
            )
          }
        } else {
          this.columnList = []
          this.columnList_odd = []
        }
      })
    },
    wxShare() {
      //分享
      let shareTitle = 'LUMI智播'
      let shareUrl = location.href
      let shareImg =
        'https://m-live-bucket.oss-cn-beijing.aliyuncs.com/2020/08/06/cc5bca97-89a8-46eb-8fd7-8f6c7c0f7ed0_f97d247b94aa981b37e164ff2f57b34.png'
      let shareDesc = '关注LUMI智播公众号，查看更多精彩直播'
      shareIndex(this, shareTitle, shareUrl, shareImg, shareDesc)
    }
  }
}
</script>

<style lang="scss" scoped>
.count {
  float: right;
  width: 100px;
  padding-top: 2px;
}
.list {
  display: flex;
  justify-content: space-around;
  text-align: center;
  margin: 10px 0;
  img {
    width: 48px;
    height: 48px;
    margin-bottom: 10px;
  }
  p {
    font-size: 14px;
  }
}
.header {
  width: 100%;
  padding-top: 1rem;
  padding-left: 10px;
  padding-right: 10px;
  display: flex;
  align-items: flex-start;
  box-sizing: border-box;
  justify-content: space-around;
  .header_img {
    width: 48px;
    height: 45px;
    margin-top: 10px;
    img {
      width: 100%;
    }
  }
}
.searchLabel {
  width: 80%;
}
/deep/ .mint-search {
  box-sizing: border-box;
  height: 100%;
}
/deep/ .mint-searchbar {
  border-radius: 4rem;
  box-sizing: border-box;
  margin-top: 1rem;
  padding: 0;
  width: 100%;
}
/deep/ .mint-searchbar-inner {
  background-color: #eee;
  padding: 0.5rem 2rem;
  border-radius: 4rem;
  font-size: 14px;
  height: 35px;
}
/deep/ .mint-searchbar-inner .mintui-search {
  font-size: 14px;
}
/deep/ .mint-searchbar-core {
  background-color: #eee;
  padding-left: 1rem;
}
/deep/ .mint-loadmore-top {
  text-align: center;
  height: 34px;
  line-height: 34px;
}
.noCourse {
  text-align: center;
  padding: 20px 0;
  color: #666;
  font-size: 14px;
}
/* 每一个图文项目的外层 */
a {
  text-decoration: none;
  color: #333;
}
.inforItemText {
  margin-left: 2rem;
  width: 65%;
  // line-height: 35px;
}
/* 图文项目的标题信息 */
.infoItemTitle {
  font-size: $font-title2;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  text-overflow: -o-ellipsis-lastline;
}
/* 图文项目的内容信息(弹性布局) */
.infoItemContent:last-child {
  border-bottom: 0;
}
.infoItemContent {
  display: flex;
  align-items: center;
  padding: 0.2rem 0;
  margin: 0.2rem 0;
  width: 100%;
  border-bottom: 1px solid #eee;
  .liveImg {
    position: relative;
    .liveStatus {
      position: absolute;
      right: 0;
      bottom: 0;
      color: #fff;
      padding: 2px 1rem;
      border-radius: 1rem;
      font-size: 12px;
      background-color: rgba($color: #000000, $alpha: 0.8);
    }
  }
}
/* 图文项目的内容信息--图片 */
.infoItemImg {
  width: 100px;
  height: 75px;
  border-radius: 5px;
}
/* 图文项目的内容信息--简介 */
.infoItemDes {
  line-height: 20px;
  color: #666;
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  margin: 5px 0;
}
.infoItemDes2 {
  line-height: 15px;
  color: #666;
  overflow: hidden;
  font-size: 10px;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  // margin: 5px 0;
}
.infoItemPrice {
  font-size: 14px;
  color: #999;
  padding-bottom: 5px;
  .free {
    padding: 2px;
    margin-right: 1rem;
    font-size: 12px;
    background-color: $theme-color;
    border-radius: 3px;
    color: #fff;
  }
  .price {
    padding: 2px;
    margin-right: 1rem;
    color: $theme-color;
    span {
      margin-left: 5px;
    }
  }
}
footer {
  background-color: #fff;
}
.columns {
  img {
    width: 20px;
    margin-bottom: 5px;
    margin-right: 10px;
  }
}
.column {
  padding: 1rem 0;
}
.column_p {
  font-size: $font-title;
  color: #696867;
  font-style: oblique;
  font-weight: bold;
}
.specialList {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .theme_sm {
    width: 49%;
    background: url(../../assets/img/timgg.jpg) no-repeat;
    margin-bottom: 2rem;
    border-radius: 5px;
    box-sizing: border-box;
    .theme-img {
      width: 100%;
      border-radius: 5px;
      img {
        width: 100%;
        height: 100px;
        border-radius: 5px;
      }
    }
    .theme-text {
      text-align: left;
      padding-left: 1rem;
    }
  }
  .theme {
    width: 100%;
    // background-color: #eee;
    background: url(../../assets/img/timgg.jpg) no-repeat;
    margin-bottom: 2rem;
    border-radius: 5px;
    box-sizing: border-box;
    position: relative;
    // height: 250px;
    .theme-img {
      position: relative;
      width: 100%;
      border-radius: 5px;
      img {
        width: 100%;
        height: 150px;
        border-radius: 5px;
      }
    }
    .theme-text {
      text-align: left;
      padding-left: 1rem;
    }
  }
}
.swipe {
  margin-bottom: 10px;
  height: 18rem;
  width: 100%;
}
.swipe img {
  display: block;
  border-radius: 10px;
  width: 100%;
  height: 100%;
}
.indexView {
  height: 100%;
  margin: 15px;
  margin-top: 5px;
}
main {
  margin-bottom: 6rem;
}
</style>
